import * as yup from "yup";

const camToGcodeSchema = yup.object().shape({
  prtUploadIds: yup
    .array()
    .required()
    .label("Part File Upload")
    .typeError("Part File Upload must be a url."),
  machineBrand: yup
    .string()
    .required()
    .label("Machine Brand")
    .typeError("Machine Brand must be a text."),
  machineModel: yup
    .string()
    .required()
    .label("Machine Model")
    .typeError("Machine Model must be a text."),
  spindleName: yup
    .string()
    .label("Spindle Name")
    .typeError("Spindle name is a required field."),
  spindleSpeed: yup
    .string()
    .required()
    .label("Spindle Speed")
    .typeError("Spindle speed must be a number."),
  maxTorque: yup
    .number()
    .label("Max Torque")
    .typeError("Max Torque Id must be a number."),
  maxPower: yup
    .number()
    .label("Max Power")
    .typeError("Max Power must be a number."),
  dimensionalTolerance: yup
    .number()
    .required()
    .label("Dimensional Tolerance")
    .typeError("Dimensional Tolerance must be a number."),
  surfaceRoughness: yup
    .number()
    .required()
    .label("Surface Roughness")
    .typeError("Surface Roughness must be a number."),
  controllerBrand: yup
    .string()
    .label("Controller Brand")
    .typeError("Controller Brand must be a text."),
  controllerModel: yup
    .string()
    .label("Controller Model")
    .typeError("Controller Model must be a text."),
  materialName: yup
    .string()
    .required()
    .label("Material Name")
    .typeError("Material Name must be a text."),
  fixturingInfo: yup
    .string()
    .label("Fixturing Info")
    .typeError("Fixturing Info must be a text."),
  notes: yup.string().label("Notes").typeError("Notes section must be a text."),
  sessionType: yup
    .string()
    .required()
    .label("Session Type")
    .typeError("Session Type must be a text."),
  cuttingToolIds: yup
    .array()
    .min(1, "There must be at least one tool entry")
    .required()
    .label("Cutting Tools"),
});

export default camToGcodeSchema;
